<template>
    <ModalFormCard :action="'/actions/crm-refill-payment/' + this.subscription.id" 
        :getUserAfterSave='true'
        class="modal-default lg:!w-[500px]"
    >
        <template #title>Manual refill</template>

        <template #default="{ saving, errors }">
            <p class="text-14">Top up your balance with a one-off payment</p>

            <div class="bg-grey-300 px-6 py-3 mt-4">
                <p class="font-semibold text-15">Good to know</p>
                <p class="text-grey-900 text-14">
                    If you forget to refill your balance and it drops below zero, some of Zapo CRM's features will stop working. Set up an
                    <button
                        class="link-text text-purple-600"
                        type="button"
                        @click="
                            $pop('CrmAutoRefill', {
                                editingModel: editingModel,
                                options: {
                                    cards: lCards,
                                },
                            })
                        "
                    >
                        auto refill plan
                    </button>
                    to avoid disruption.
                </p>
            </div>

            <template v-if="subscription.hasCrmUnpaidInvoice()">
                <p class="mt-6 text-15 text-grey-900">
                    You have an unpaid invoice totalling {{ $help.dp(subscription.crmUnpaidInvoice().sub_total) }}+VAT which you need to pay
                    for first. Last reason for failed payment:
                    <span class="text-black">{{ subscription.crmUnpaidInvoice().last_invoice.last_payment.fail_message }}</span>
                </p>
            </template>

            <Select
                placeholder="Select amount"
                label="Refill amount"
                class="mt-6"
                :options="amounts"
                v-model:value="value.amount"
                :disabled="saving || subscription.hasCrmUnpaidInvoice()"
                name="amount"
            />

            <Select
                v-if="lCards"
                class="mt-4"
                v-model:value="value.card_id"
                :disabled="saving"
                :options="lCards"
                label="Payment method"
                menuClass="!bg-grey"
                menuMaxHeight="80px"
                name="card_id"
                placeholder="Select a card"
                selectClass="!bg-grey text-15"
                selectedCSS=""
                valueKey="id"
            >
                <template #label-right>
                    <button class="link-text text-purple-600 text-13" type="button" @click="addNew()">Add new card</button>
                </template>

                <template #option="{ option, selected }">
                    <div class="flex items-center w-full" v-if="option.html != 'Add new card'">
                        <PaymentMethodTable :paymentMethod="option" :table="false" :disabled="saving" />

                        <div class="flex items-center ml-4" v-if="option.default_payment_method != null">
                            <IconTrue class="stroke-white w-5 h-5 bg-black rounded-full" />

                            <p class="text-15 pl-2">Default</p>
                        </div>
                    </div>

                    <p v-else>{{ option.html }}</p>
                </template>
            </Select>

            <div class="modal-buttons">
                <ButtonSaving :disabled="saving" class="button-black h-12 default !text-13">Make payment and refill now</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    async created() {
        if (this.options.cards == undefined || this.options.currentValue != null) {
            this.lCards = await this.$axios.get('/actions/user-get-cards')
            this.lCards.push({ html: 'Add new card', id: 'add' })
        } else {
            this.lCards = this.options.cards
        }

        if (this.options.currentValue != null) {
            this.value = this.options.currentValue
        }

        this.value.card_id =
            this.subscription.stripe_payment_method_id != null
                ? this.lCards.find((c) => c.stripe_card_id == this.subscription.stripe_payment_method_id).id
                : this.lCards.find((c) => c.default_payment_method != null).id
    },

    data() {
        return {
            amounts: [
                { value: 10, html: this.$help.dp(10) },
                { value: 25, html: this.$help.dp(25) },
                { value: 50, html: this.$help.dp(50) },
                { value: 75, html: this.$help.dp(75) },
                { value: 100, html: this.$help.dp(100) },
            ],
            value: {
                card_id: null,
                amount: this.editingModel.hasCrmUnpaidInvoice() != null ? this.editingModel.crmUnpaidInvoice().sub_total : null,
            },
            lCards: null,
        }
    },

    methods: {
        addNew() {
            this.$event.$emit('modal-open', {
                view: 'PaymentMethodCreate',
                lastModal: {
                    view: 'CrmRefill',
                    editingModel: this.editingModel,
                    options: { ...this.options, currentValue: this.value },
                },
            })
        },
    },

    computed: {
        subscription() {
            return this.editingModel
        },

        // lastPayment() {
        //     return this.crmUnpaidInvoice ? this.crmUnpaidInvoice.payments[this.crmUnpaidInvoice.payments.length - 1] : null
        // },
    },
}
</script>
